import { useLocalizedText } from '../localizedText';
import { TableProps } from '@amzn/awsui-components-react/polaris/table';

export function useTableStrings<T>(
  tablePrefix: string,
  selectionLabel: (item: T) => string,
  namespaces: string[] = ['translation']
): {
  ariaLabels: TableProps.AriaLabels<T>;
  renderAriaLive: (data: TableProps.LiveAnnouncement) => string;
  enableKeyboardNavigation: true;
  loadingText: string;
} {
  const { t } = useLocalizedText(namespaces);

  return {
    ariaLabels: {
      selectionGroupLabel: t([`${tablePrefix}.selectionGroupLabel`, `table.selectionGroupLabel`]),
      allItemsSelectionLabel: ({ selectedItems }) =>
        t([`${tablePrefix}.allItemsSelectionLabel`, `table.allItemsSelectionLabel`], {
          count: selectedItems.length,
        }),
      itemSelectionLabel: ({ selectedItems }, item) => selectionLabel(item),
      submitEditLabel: (column) =>
        t([`${tablePrefix}.submitEditLabel`, `table.submitEditLabel`], {
          header: String(column.header),
        }),
    },
    renderAriaLive: ({ firstIndex, lastIndex, visibleItemsCount, totalItemsCount }) =>
      t([`${tablePrefix}.renderAriaLive`, `table.renderAriaLive`], {
        firstIndex,
        lastIndex,
        visibleItemsCount,
        totalItemsCount,
      }),
    loadingText: t([`${tablePrefix}.loading`, `table.loading`]),
    enableKeyboardNavigation: true,
  };
}
